<template>
  <div
    class="navbar navbar-expand navbar-dark fixed-bottom justify-content-center bd-navbar p-0"
    v-bind:class="show"
  >
    <div class="navbar-nav-scroll">
      <ul @scroll="$emit('scrolling')" id="navbar-list" class="navbar-nav bd-navbar-nav">
        <li class="nav-item" v-for="item in navItems" v-bind:key="item.name">
          <a
            @click.prevent="doNav(item.href)"
            class="nav-link"
            :href="item.href"
            :data-i42-provider="item.data_provider"
          >{{item.name}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar.Bottom",
  props: {
    feeds: Object,
    routeName: String,
    visible: Boolean
  },
  computed: {
    show() {
      return {
        "d-flex": this.visible,
        "d-none": !this.visible
      };
    },
    navItems() {
      let items = [];

      let currentCategory = this.$route.params.category;
      let provider = this.feeds.items.find(function(data) {
        return data.id == currentCategory;
      });

      if (provider !== undefined) {
        var name = "";
        provider.urls.forEach((element, index) => {
          if (index % 2) {
            items.push({
              name: name + " | " + element.name,
              href: "#p" + element.id,
              data_provider: element.id
            });
            name = "";
          } else {
            name = element.name;
            if (index == provider.urls.length - 1) {
              items.push(this.createNavItem(element.id, element.name));
            }
          }
        });
      }

      return items;
    }
  },
  methods: {
    createNavItem(id, name) {
      return {
                name: name,
                href: "#p" + id,
                data_provider: id
              }
    },
    doNav(hashTo) {
      this.$router.push({ name: this.routeName, params: { category: this.$route.params.category, page: hashTo.replace('#', '') } });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-navbar {
  background-color: #563d7c;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}
.bd-navbar .navbar-nav-scroll {
  max-width: 100%;
  height: 2.5rem;
  margin-top: 0.25rem;
  overflow: hidden;
  font-size: 0.875rem;
}

.bd-navbar .navbar-nav-scroll .navbar-nav {
  padding-bottom: 2rem;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
</style>
